export const READ_INVOICE_COLLECTION = "READ_INVOICE_COLLECTION";
export const INVOICE_SET_PAGINATION = "INVOICE_SET_PAGINATION";
export const INVOICE_SET_FILTERS = "INVOICE_SET_FILTERS";
export const INVOICE_RESET_FILTERS = "INVOICE_RESET_FILTERS";
export const INVOICE_SET_SORTING = "INVOICE_SET_SORTING";
export const EVENT_INVOICE_FILTER_SUBMIT = "EVENT_INVOICE_FILTER_SUBMIT";
export const INVOICE_SET_PAY_IDS = "INVOICE_SET_PAY_IDS";
